$(document).ready(function () {
	$("#offcanvas__nav").mmenu({
		extensions: ["theme-dark"]
	});
});
